import { useSelector, shallowEqual } from "react-redux";
import MiniSearch from "app/features/SearchEngine/MiniSearch/MiniSearch";
import PropTypes from "prop-types";
import { getSelectedStopoverCity } from "app/pages/SmartDP/smartDPSelectors";
import { normalizeDate } from "app/utils/smartDPUtils";

const MiniSearchContainer = () => {
	const { itinerary } = useSelector(mapStateToProps, shallowEqual);
	return <MiniSearch itinerary={itinerary} />;
};

MiniSearchContainer.propTypes = {
	itinerary: PropTypes.shape({
		stopover: PropTypes.string,
		from: PropTypes.string,
		to: PropTypes.string.isRequired,
		dates: PropTypes.shape({
			from: PropTypes.string.isRequired,
			to: PropTypes.string.isRequired,
		}).isRequired,
		travelerCount: PropTypes.number.isRequired,
		roomCount: PropTypes.number.isRequired,
	}).isRequired,
};

const mapStateToProps = state => {
	const travelerCount = state.booking.adults + state.booking.children + state.booking.infants;

	return {
		itinerary: {
			stopover: getSelectedStopoverCity(state)?.label || "",
			from: (state.booking.departureCity.label || "").replace(/\s+\([A-Z]{3}\)$/, ""),
			to: state.booking.destinationResort.label,
			dates: {
				from: normalizeDate(state.booking.departureDate),
				to: normalizeDate(state.booking.endDate),
			},
			travelerCount,
			roomCount: state.booking.occupancies.length,
		},
	};
};

export default MiniSearchContainer;
